import { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material';

import { CloseOutlined } from '@mui/icons-material';

import TemplatesPanel from '../../../../../Common/components/Template/TemplatesPanel';
import TemplateTextPanel from '../../../../../Common/components/Template/TemplateTextPanel';
import { dialogHeaderStyles } from '../../../../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../../../../Common/components/CommonDialogActions';
import {dialogContentSx,dialogPaperSx,panelsWrapperSx} from './Styles'



const closeIconSx = {
  fontSize: 22
};

const initialTopics = [
  {
    id: 1,
    title: 'Abdominal Pain'
  },
  {
    id: 2,
    title: 'Annual H&P'
  },
  {
    id: 3,
    title: 'Chest Pain'
  },
  {
    id: 4,
    title: 'Chest Pain'
  },
  {
    id: 5,
    title: 'Knee Pain'
  },
  {
    id: 6,
    title: 'Nausea & Vomiting'
  },
  {
    id: 7,
    title: 'URI'
  },
  {
    id: 8,
    title: 'UTI'
  },
  {
    id: 9,
    title: 'Venous Insufficiency'
  }
];

const initialTemplateText = {
  1: [
    {
      id: 1,
      text: 'Patient has associated nausea, vomiting with the abdominal pain.',
      checked: false
    },
    {
      id: 2,
      text: 'Patient denied hematochezia or melena.',
      checked: false
    },
    {
      id: 3,
      text: 'Patient denied recent traveling or eating out in a restaurant.',
      checked: false
    }
  ]
};

const SubjectiveTemplatesDialog = ({ open, onClose, onSave }) => {
  const [topics, setTopics] = useState(initialTopics);
  const [selectedTopicId, setSelectedTopicId] = useState(1);
  const [templateText, setTemplateText] = useState(initialTemplateText);

  const selectedTopic =
    topics.find(topic => topic.id === selectedTopicId) || topics[0];

  const selectedTemplateText = templateText[selectedTopicId] || [];

  const handleAddTopic = value => {
    const nextId =
      topics.length > 0
        ? Math.max(...topics.map(topic => topic.id)) + 1
        : 1;

    const newTopic = {
      id: nextId,
      title: value
    };

    setTopics(previous => [...previous, newTopic]);
    setSelectedTopicId(nextId);

    setTemplateText(previous => ({
      ...previous,
      [nextId]: []
    }));
  };

  const handleEditTopic = topic => {
    console.log('Edit topic:', topic);
  };

  const handleAddText = value => {
    const currentRows = templateText[selectedTopicId] || [];

    const nextId =
      currentRows.length > 0
        ? Math.max(...currentRows.map(item => item.id)) + 1
        : 1;

    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: [
        ...currentRows,
        {
          id: nextId,
          text: value,
          checked: true
        }
      ]
    }));
  };

 const handleToggleText = id => {
  setTemplateText(previous => ({
    ...previous,
    [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
      item.id === id
        ? {
            ...item,
            checked: !item.checked
          }
        : item
    )
  }));
};
  const handleEditText = (itemId, updatedText) => {
    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: (previous[selectedTopicId] || []).map(item =>
        item.id === itemId
          ? {
              ...item,
              text: updatedText
            }
          : item
      )
    }));
  };

  const handleReorderText = reorderedRows => {
    setTemplateText(previous => ({
      ...previous,
      [selectedTopicId]: reorderedRows
    }));
  };

const handleSave = () => {
  const selectedRows = templateText[selectedTopicId] || [];

  const selectedText = selectedRows
    .filter(item => item.checked)
    .map(item => item.text)
    .join('\n');

  onSave({
    text: selectedText,
    topics,
    selectedTopicId,
    templateText
  });

  onClose();
};

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={false}
      slotProps={{
        paper: {
          sx: dialogPaperSx
        }
      }}
    >
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Subjective Templates
          </Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
            Create and manage templates for documenting patient-reported findings.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close subjective templates dialog"
          onClick={handleClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}
        >
          <CloseOutlined sx={closeIconSx} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={dialogContentSx}>
        <Box sx={panelsWrapperSx}>
          <TemplatesPanel
            topics={topics}
            selectedTopicId={selectedTopicId}
            onSelectTopic={setSelectedTopicId}
            onAddTopic={handleAddTopic}
            onEditTopic={handleEditTopic}
          />

          <TemplateTextPanel
            title={selectedTopic?.title || 'Template'}
            rows={selectedTemplateText}
            onAddText={handleAddText}
            onToggleText={handleToggleText}
            onEditText={handleEditText}
            onReorderText={handleReorderText}
            showCheckbox={true}
          />
        </Box>
      </DialogContent>

      <CommonDialogActions
        onCancel={handleClose}
        onSubmit={handleSave}
        submitText="Save"
        disabled={false}
      />
    </Dialog>
  );
};

SubjectiveTemplatesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func
};

SubjectiveTemplatesDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSave: () => {}
};

export default SubjectiveTemplatesDialog;